// extracted by mini-css-extract-plugin
module.exports = {"textBlock":"PageUITextBlock_textBlock__0mvxA"};